import { render, staticRenderFns } from "./Atenciones.vue?vue&type=template&id=801f426a&scoped=true&"
import script from "./Atenciones.vue?vue&type=script&lang=js&"
export * from "./Atenciones.vue?vue&type=script&lang=js&"
import style0 from "./Atenciones.vue?vue&type=style&index=0&id=801f426a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801f426a",
  null
  
)

export default component.exports